
const url_header = process.env.API_ROOT //获取当前环境下的域名

export const updataImage = url_header + 'mini/mini-task/task-img-upload' //上传图片

export const loginUser = url_header + 'admin/login' //登录

export const companyAuthList = url_header + 'admin/ep-user/auth-list' //企业认证信息列表

export const exportCompanyList = url_header + 'admin/ep-user/ep-export' //企业认证信息列表数据导出

export const companyType = url_header + 'mini/mini-master-user/identy' //企业行业信息

export const authCompany = url_header + 'admin/ep-user/save-ep-info' //企业认证

export const modifyCompany = url_header + 'admin/ep-user/save-ep-info' //企业信息修改

export const companyRecharge = url_header + 'admin/ep-user/ep-recharge'//企业充值

export const openVipCom = url_header + 'admin/ep-user/upgrade-ep'//企业开通会员

export const complanyBalance = url_header + 'mini/mini-master-user/enterprise-balance' //企业收支明细

export const darenAuthList = url_header + 'admin/pc-user/auth-list' //达人认证信息列表

export const exportDarenList = url_header + 'admin/pc-user/pc-export' //达人认证信息列表数据导出

export const authDaren = url_header + 'admin/pc-user/save-pc-info' //达人认证

export const modifyDaren = url_header + 'admin/pc-user/save-pc-info' //达人信息修改

export const darenRecharge = url_header + 'admin/pc-user/pc-recharge'//达人充值

export const darenBalance = url_header + 'mini/mini-master-user/personal-balance' //达人收支明细

export const occupation = url_header + 'mini/mini-master-user/occupation' //达人职业列表

export const cashList = url_header + 'admin/withdrawal/list' //达人提现申请

export const editCash = url_header + 'admin/withdrawal/edit' //达人提现操作

export const headLines = url_header + 'admin/headline/list' //达人头条列表

export const editHeadLines = url_header + 'admin/headline/update' //达人头条编辑

export const addHeadLines = url_header + 'admin/headline/add' //达人头条添加

export const orderList = url_header + 'admin/task/list' //订单列表

export const orderDetail = url_header + 'admin/task/info' //订单详情

export const exportOrderList = url_header + 'admin/task/task-export' //订单列表导出

export const orderCompanyInfo = url_header + 'admin/task/ep-info' //订单列表企业信息

export const orderExamine = url_header + 'admin/task/examine' //订单审核

export const modifyTaskTime = url_header + 'admin/task/task-edit' //修改订单时间

export const lookResumeData = url_header + 'admin/resume/list' //查看订单简历

export const zhanzhangList = url_header + 'admin/pc-user/agent-list' //站长列表

export const zhanzhangSet = url_header + 'admin/pc-user/save-agent' //设置、取消站长

export const replaceOrderList = url_header + 'admin/pc-user/agent-task-list' //代客下单列表

export const applyZhanzhangList = url_header + 'admin/agent/apply-list' //站长申请列表

export const applyZhanzhangRemark = url_header + 'admin/agent/apply-remark' //站长申请备注

export const delApplyZhanzhang = url_header + 'admin/agent/del-apply' //删除站长申请

export const peixunList = url_header + 'admin/pc-user/train-list' //培训列表

export const peixunDetail = url_header + 'admin/pc-user/train-detailed' //培训详情

export const exportPeixun = url_header + 'admin/pc-user/train-export' //培训详情名单导出

export const addPeixun = url_header + 'admin/pc-user/add-train' //新增培训

export const taskPriceType = url_header + 'mini/mini-master-user/price-type' //获取任务价格套餐

export const savePriceType = url_header + 'admin/conf-info/add-price' //保存任务价格套餐

export const deletePriceType = url_header + 'admin/conf-info/delete-price' //删除任务价格套餐

export const orderSetData = url_header + 'admin/conf-info/get-config' //订单设置模块显示的内容

export const setOrderSetData = url_header + 'admin/conf-info/update-config' //设置订单设置模块显示的内容

export const rechargePrice = url_header + 'mini/mini-master-user/recharge-price' //获取充值价格数据

export const saveRechargePrice = url_header + 'admin/conf-info/add-recharge-price' //保存充值价格数据

export const delRechargePrice = url_header + 'admin/conf-info/delete-recharge-price' //删除充值价格数据

export const inviteRecord = url_header + 'mini/mini-master-user/invitation-record' //站长邀请记录

export const operator = url_header + 'mini/mini-master-user/ep-operater' //运营者账号

export const flowStatisticsCom = url_header + 'admin/ep-user/ep-flow' //企业流水明细

export const flowStatisticsDaren = url_header + 'admin/pc-user/pc-flow' //达人流水明细

export const exportCompanyFlow = url_header + 'admin/ep-user/ep-flow-export' //企业流水明细导出

export const exportDarenFlow = url_header + 'admin/pc-user/pc-flow-export' //达人流水明细导出

export const getArea = url_header + 'admin/conf-info/get-area' //获取区域

export const addArea = url_header + 'admin/conf-info/add-area' //添加区域

export const delArea = url_header + 'admin/conf-info/delete-area' //删除区域

export const joinCompanyData = url_header + 'admin/business/list' //招商加盟数据

export const modifyRemark = url_header + 'admin/business/remark' //招商加盟备注修改

export const joinCompanyDetailData = url_header + 'admin/business/info' //招商加盟数据详情

export const roleList = url_header + 'admin/rbac/item-list' //默认权限列表

export const addRole = url_header + 'admin/rbac/add-role' //添加角色

export const justList = url_header + 'admin/rbac/role-list' //角色列表

export const delRole = url_header + 'admin/rbac/del-role' //删除角色

export const updateRole = url_header + 'admin/rbac/update-role' //编辑角色

export const userList = url_header + 'admin/rbac/user-list' //用户列表

export const addUser = url_header + 'admin/rbac/add-user' //添加用户

export const delUser = url_header + 'admin/rbac/del-user' //删除用户

export const updateUser = url_header + 'admin/rbac/update-user' //编辑用户

export const userDaily = url_header + 'admin/rbac/admin-log' //用户日志

export const modifyPassword = url_header + 'admin/rbac/update-password' //修改密码

export const modifyCommisionLog = url_header + 'admin/conf-info/invitation-config-log' //站长修改奖励列表

export const WorkbenchData = url_header + 'admin/work-table/statistics-info' //工作台数据统计

export const serverStatus = url_header + 'api/front-desk/service-status' //验证软件使用状态

export const payServer = url_header + 'api/front-desk/pay-service-charge' //支付服务费

export const queryServer = url_header + 'api/front-desk/get-pay-result' //查询支付结果

export const systemInfo = url_header + 'api/front-desk/get-notice' //获取系统公告

export const exportZhanzhang = url_header + 'admin/pc-user/agent-export' //达人站长导出

export const drawData = url_header + 'admin/award/list' //抽奖中奖名单

export const exportDrawData = url_header + 'admin/award/award-export' //中奖名单导出

export const drawDetailData = url_header + 'admin/award/info' //中奖详情

export const drawRemark = url_header + 'admin/award/update' //中奖备注

export const couponListData = url_header + 'admin/coupon/list' //奖品管理优惠券列表

export const couponRecordListData = url_header + 'admin/coupon/coupon-record-list' //奖品管理优惠券领券记录

export const expercardListData = url_header + 'admin/experience-card/list' //奖品管理体验卡列表

export const expercardRecordListData = url_header + 'admin/experience-card/card-record-list' //奖品管理体验卡领卡记录

export const goodsListData = url_header + 'admin/goods/list' //奖品管理实物列表

export const goodsRecordListData = url_header + 'admin/goods/goods-record-list' //奖品管理实物领取记录

export const exchangeListData = url_header + 'admin/exchange-gift/exchange-list' //兑换管理列表

export const exportExchangeList = url_header + 'admin/exchange-gift/exchange-export' //兑换列表导出

export const editExchange = url_header + 'admin/exchange-gift/update-record' //发放、备注兑换

export const giftListData = url_header + 'admin/exchange-gift/list' //礼品管理列表

export const exportGiftList = url_header + 'admin/exchange-gift/gift-export' //礼品列表导出

export const addGift = url_header + 'admin/exchange-gift/add' //新增礼品

export const editGift = url_header + 'admin/exchange-gift/update' //编辑礼品

export const giftRecord = url_header + 'admin/exchange-gift/exchange-record' //礼品兑换记录

export const goldFlowData = url_header + 'admin/exchange-gift/gold-record-list' //金币流水

export const exportGoldFlow = url_header + 'admin/exchange-gift/gold-record-export' //金币流水导出









// WEBPACK FOOTER //
// ./src/config/api.js